import { render, staticRenderFns } from "./DialogUpdateContractDate.vue?vue&type=template&id=b6a35ed6&"
import script from "./DialogUpdateContractDate.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateContractDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports